'use strict';

var _classCallCheck = require("/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/ordex_mobile/Desktop/Rushabh/Learning/bet/betlights/node_modules/@babel/runtime/helpers/createClass");
var Response = /*#__PURE__*/function () {
  function Response(statusCode, body, headers) {
    _classCallCheck(this, Response);
    this.statusCode = statusCode;
    this.body = body;
    this.headers = headers;
  }
  _createClass(Response, [{
    key: "toString",
    value: function toString() {
      return 'HTTP ' + this.statusCode + ' ' + this.body;
    }
  }]);
  return Response;
}();
module.exports = Response;